"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { useIsDarkTheme } from "../theme-provider/provider";

type Props = {
  src: string;
  alt: string;
};

export default function ClientImage({ src, alt }: Props) {
  const isDarkMode = useIsDarkTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  // Default to light overlay during SSR to match server-rendered HTML
  // This prevents hydration mismatch
  const overlayImage =
    mounted && isDarkMode
      ? "/assets/background/overlay_dark.svg"
      : "/assets/background/overlay_light.svg";

  return (
    <div className="relative w-full h-[35vh] overflow-hidden">
      <Image src={src} alt={alt} fill className="z-[-1] object-cover" />
      <div
        className="absolute inset-0 bg-cover opacity-50"
        style={{ backgroundImage: `url(${overlayImage})` }}
      ></div>
    </div>
  );
}
